import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../../../constant/queryKey';
import { retailAdService } from 'shared/src/api';

/**
 * iOS OverviewFeature 의 fetchRetailAds() / Android RetailAdEventStateImpl.onCall()
 * 처럼 OverView 진입마다 새로 광고를 조회하도록 캐시를 비활성화.
 * - gcTime: 0   → unmount 즉시 캐시 폐기. 다음 mount 시 'pending' 상태로 시작.
 * - staleTime: 0 → 항상 stale 상태로 mount.
 * 효과: 매 진입마다 CALL_ADS → fetch → LOAD_ADS 흐름이 native 와 동일하게 발화.
 */
export const useRetailAd = (adSlotId: number) => {
  return useQuery({
    queryKey: queryKey.retailAd(adSlotId),
    queryFn: () => retailAdService.getRetailAd(adSlotId),
  });
};
